module.exports = __webpack_public_path__ + "img/medal-silver.3a0cee2b.png";